function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18,2.438 L18,1.563 C18,1.252 17.748,1.001 17.438,1.001 L6.562,1.001 C6.252,1.001 6,1.252 6,1.563 L6,2.438 C6,2.749 6.252,3 6.562,3 L17.438,3 C17.748,3 18,2.749 18,2.438 M2,0 C0.896,0 0,0.896 0,2.001 C0,3.105 0.896,4 2,4 C3.104,4 4,3.105 4,2.001 C4,0.896 3.104,0 2,0 M18,9.438 L18,8.563 C18,8.252 17.748,8 17.438,8 L6.562,8 C6.252,8 6,8.252 6,8.563 L6,9.438 C6,9.749 6.252,10 6.562,10 L17.438,10 C17.748,10 18,9.749 18,9.438 M2,7 C0.896,7 0,7.896 0,9 C0,10.105 0.896,11.001 2,11.001 C3.104,11.001 4,10.105 4,9 C4,7.896 3.104,7 2,7 M18,16.438 L18,15.563 C18,15.252 17.748,15.001 17.438,15.001 L6.562,15.001 C6.252,15.001 6,15.252 6,15.563 L6,16.438 C6,16.749 6.252,17.001 6.562,17.001 L17.438,17.001 C17.748,17.001 18,16.749 18,16.438 M4,16.001 C4,17.105 3.104,18.001 2,18.001 C0.896,18.001 0,17.105 0,16.001 C0,14.896 0.896,14.001 2,14.001 C3.104,14.001 4,14.896 4,16.001",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-1 -1 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/list.e0b6836d.svg";
export { SvgComponent as ReactComponent };